/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostAccessCheckBulkPathParams = NonNullable<operations['postAccessCheckBulk']['parameters']['path']>;

export type PostAccessCheckBulkRequestBody = OperationRequestBodyContent<operations['postAccessCheckBulk']>;

export interface Input extends PostAccessCheckBulkPathParams {
  apiVersion?: string;
  body: PostAccessCheckBulkRequestBody;
  header: NonNullable<operations['postAccessCheckBulk']['parameters']['header']>;
}

export async function postAccessCheckBulk(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/authorization/access-check/{service}/bulk', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
